module.exports = __webpack_public_path__ + "static/daniel-dc2e85b5c445eb5d3e4c25dd170a95b0.jpg";